<template>
    <v-container fill-height fluid pa-0 style="user-select: none;">
        <v-row align="center" class="fill-height" justify="center" no-gutters>
            <v-col cols="6">
                <page-heading :text="$t('views.speedtest.failed_title')" class="mb-5" text-center></page-heading>
                <div class="font-weight-bold text-center mb-5">
                    {{$t('views.speedtest.failed_desc')}}
                </div>
                <v-row justify="space-between" no-gutters>
                    <v-col class="text-center my-5" cols="6">
                        <v-row justify="center" align="end" no-gutters>
                            <v-col cols="auto">
                                <v-tooltip left open-on-hover max-width="250">
                                    <template v-slot:activator="{ on }">
                                        <v-progress-circular v-on="on" size="40" value="100" width="1">
                                            <v-icon size="22">mdi-arrow-down</v-icon>
                                        </v-progress-circular>
                                    </template>
                                    <div>
                                      {{$t('views.speedtest.download_desc')}}
                                    </div>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="ml-2">
                                <div class="font-weight-medium text-start" style="text-transform: uppercase"> {{$t('views.speedtest.download')}}</div>
                                <v-row align="end" class="flex-nowrap" justify="start" no-gutters>
                                    <page-heading :text="downloadSpeed.toFixed(2)" class="mr-1"></page-heading>
                                    <span class="grey--text">Mbps</span>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="text-center my-5" cols="6">
                        <v-row justify="center" align="end" no-gutters>
                            <v-col cols="auto">
                                <v-tooltip right nudge-right="120" open-on-hover max-width="250">
                                    <template v-slot:activator="{ on }">
                                        <v-progress-circular v-on="on" size="40" value="100" width="1">
                                            <v-icon size="22">mdi-arrow-up</v-icon>
                                        </v-progress-circular>
                                    </template>
                                    <div>

                                      {{$t('views.speedtest.upload_desc')}}
                                    </div>
                                </v-tooltip>
                            </v-col>
                            <v-col cols="auto" class="ml-2">
                                <div class="font-weight-medium text-start" style="text-transform: uppercase"> {{$t('views.speedtest.upload')}}</div>
                                <v-row align="end" class="flex-nowrap" justify="start" no-gutters>
                                    <page-heading :text="uploadSpeed.toFixed(2)" class="mr-1"></page-heading>
                                    <span class="grey--text">Mbps</span>
                                </v-row>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" class="d-flex justify-center mt-5">
                        <v-btn color="grey"
                               large
                               class="mx-2"
                               @click="continueWithConnection()"
                        >{{$t('general.continue')}}
                        </v-btn>
                        <v-btn color="secondary"
                               large
                               class="mx-2"
                               @click="resetConnection()"
                        >{{$t('views.speedtest.retest')}}
                        </v-btn>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import PageHeading from "../PageHeading";

    export default {
        name: "SpeedTestFailed",
        components: {
            PageHeading
        },
        props: {
          uploadSpeed: {
            required: true
          },
          downloadSpeed: {
            required: true
          }
        },
        data: () => ({

        }),
        methods: {
            continueWithConnection() {
               this.$emit('accept');
            },
            resetConnection() {
               this.$emit('test');
            }
        }
    }
</script>

<style scoped>

</style>